function integrationDefaultValuesConstant() {
    return {
        POS_DEFAULT_VALUES: {
            Micros: {
                payAtTable: false,
                barTab: false,
                collection: false,
                orderAtTable: false
            },
            Comtrex: {
                payAtTable: true,
                isBillAutoUpdate: true
            },
            Quadranet: {
                payAtTable: true,
                isBillAutoUpdate: true
            },
            IBS: {
                payAtTable: true,
                isBillAutoUpdate: true
            },
            Pilot: {
                payAtTable: true,
                isBillAutoUpdate: true
            },
            Zonal: {
                payAtTable: true,
                isBillAutoUpdate: false
            },
            Paymentez: {
                collection: true
            },
            Omnivore: {
                payAtTable: true,
                usePaymentType: true,
                isBillAutoUpdate: true,
                autoBilling: true
            },
            Eunoia: {
                collection: true,
                collectionWithTimeSlots: true
            },
            Ncr: {
                payAtTable: true
            },
            Demo: {
                payAtTable: false,
                barTab: false,
                collection: true,
                collectionWithTimeSlots: true,
                isBillAutoUpdate: true
            }
        },
        FULFILMENT_DEFAULT_VALUES: {
            defaultType: {
                collection: true,
                collectionWithTimeSlots: false
            }
        }
    }
}
angular.module('qkr.integration.settings')
    .constant('integrationDefaultValuesConstant', integrationDefaultValuesConstant());


// WEBPACK FOOTER //
// ./src/integration-settings/constants/integration.default.values.constant.js